import ConfigManager from '@/config/ConfigManager.js';
import Account from '@/helper/AccountHelper.js';
import Locale from '@/helper/locale/Locale.js';

export function WebInterfaceController(campaign) {
    this.localeCode = Locale.getLocaleCode();
    this.urlInterface = campaign.website;

    this.openInterface = function () {
        let isShowHeader = 'false';
        let theme = ConfigManager.getAppName();
        let appName = ConfigManager.getAppName();
        let suffledToken = Account.getTokenShuffle();
        let historyCount = this.getHistoryCount();
        let returnUrl = window.location.href + '?back=' + historyCount;

        let url = this.urlInterface
            + '&token=' + suffledToken
            + '&locale=' + this.localeCode
            + '&header=' + isShowHeader
            + '&theme=' + theme
            + '&appName=' + appName
            + '&return_url=' + encodeURIComponent(returnUrl);

        // support history truemoney
        if (this.isTrueMoney()) {
            url += '&history_url=' + encodeURIComponent(window.location.href + '/history');
        }

        if (historyCount == 0) {
            window.location.replace(url);
        } else {
            window.location = url;
        }
    };

    this.openHistoryInterface = function () {

    };

    this.getHistoryCount = function() {
        if (this.isStarbuck()) {
            return -2;
        } else if (this.isTopup()) {
            return -3;
        } else if (this.isAirasia()) {
            return 'airasia';
        } else if (this.isInternet()) {
            return -2;
        } else {
            return 0;
        }
    };

    this.isTrueMoney = function () {
        return (this.urlInterface.indexOf('wondd/truemoney') == -1 && this.urlInterface.indexOf('truemoney') >= 0);
    };

    this.isStarbuck = function () {
        return (this.urlInterface.indexOf('starbucks') >= 0);
    };

    this.isTopup = function () {
        return (this.urlInterface.indexOf('/Topup/InterfaceLanding') >= 0)
    };

    this.isAirasia = function () {
        return (this.urlInterface.indexOf('airasia') >= 0)
    };
    this.isInternet = function () {
        return (this.urlInterface.indexOf('/Landing/') >= 0)
    };
}
